<div 
  class="accordion" 
  [class.disabled]="disabled()" 
  [class.open]="isOpen()">
  <div class="accordion-header" (click)="toggle()">
    <span class="accordion-title">{{ title() }}</span>
    <button class="accordion-toggle" [class.open]="isOpen()" type="button">
      <ng-icon name="iconoirNavArrowDown" size="20" strokeWidth="2"></ng-icon>
    </button>
  </div>
  <div class="accordion-content" [class.open]="isOpen()">
    <div class="accordion-body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
